import type { DetectedLink } from '../../integrations';

export function detectZoomLink(url: string): DetectedLink | null {
  try {
    const u = new URL(url);
    const host = u.hostname.toLowerCase();
    if (!host.endsWith('zoom.us') && !host.endsWith('zoom.com')) return null;
    const pathParts = u.pathname.split('/').filter(Boolean);
    if (pathParts.length >= 2 && (pathParts[0] === 'j' || pathParts[0] === 's' || pathParts[0] === 'my')) {
      const meetingId = pathParts[1].replace(/\s/g, '');
      if (meetingId.length >= 9) {
        return {
          url,
          integrationType: 'zoom',
          resourceType: 'meeting',
          resourceId: meetingId,
          zoomMeetingId: meetingId,
        };
      }
    }
  } catch {
    /* invalid URL */
  }
  return null;
}
